import { render, staticRenderFns } from "./editForm.vue?vue&type=template&id=0ddee4e4&scoped=true&"
import script from "./editForm.vue?vue&type=script&lang=ts&"
export * from "./editForm.vue?vue&type=script&lang=ts&"
import style0 from "./editForm.vue?vue&type=style&index=0&id=0ddee4e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddee4e4",
  null
  
)

export default component.exports